module.exports = __webpack_public_path__ + "static/media/green-mobility-2.59184796.jpg";